import type { AdditionalData } from '../../api/get-digital-twins';

export type DigiTwinShareMode = 'create' | 'edit';
export type DigiTwinShareValues = AdditionalData & { expiresIn: string; name: string };
export type DigiTwinShareSubmitMeta = { expirationChanged: boolean };

export const defaultFormValues: DigiTwinShareValues = {
  name: '',
  expiresIn: '7',
  editingMode: 'view',
  settings: true,
  showMeasurements: true,
  showRoomArea: true,
  roundRoomArea: true,
  showFurniture: true,
  showCompass: true,
  showRoofs: true,
  showFocusPoints: true,
  showExterior: true,
  transparentWalls3d: true,
  snappingActive: true,
};

const displaySettingKeys = [
  'showMeasurements',
  'showRoomArea',
  'roundRoomArea',
  'showFurniture',
  'showCompass',
  'showRoofs',
  'showFocusPoints',
  'showExterior',
  'transparentWalls3d',
] as const satisfies readonly (keyof AdditionalData)[];

const limitedSettingKeys = [
  ...displaySettingKeys,
  'snappingActive',
] as const satisfies readonly (keyof AdditionalData)[];

export type ShareSettingKey = (typeof limitedSettingKeys)[number];

export function getVisibleShareSettings(editingMode: AdditionalData['editingMode']) {
  return editingMode === 'limited' ? limitedSettingKeys : displaySettingKeys;
}
